import { render } from "./Service.vue?vue&type=template&id=3e0f7996&scoped=true"
import script from "./Service.vue?vue&type=script&lang=ts"
export * from "./Service.vue?vue&type=script&lang=ts"

import "./Service.vue?vue&type=style&index=0&id=3e0f7996&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3e0f7996"

export default script